import React from 'react';
import { Asset } from '../../../types/asset';
import { RichText } from '../../richText';
import { Document } from '@contentful/rich-text-types';
import classnames from 'classnames';
import { Block } from '../../other/block';

export interface ImageTextProps {
  name: string;
  image: Asset;
  text: Document;
  textFirst: string;
  backgroundColour?: string;
}

export const ImageText: React.FC<ImageTextProps> = ({ image, text, textFirst, backgroundColour }) => {
  const className = classnames('w-full mx-auto flex flex-col md:flex-row', {
    'md:flex-row-reverse': textFirst,
  });

  return (
    <Block backgroundColour={backgroundColour} noSpacing={true}>
      <div className={className}>
        <div
          className="bg-center bg-cover h-96 sm:h-screen-half md:w-1/2 md:h-auto"
          style={{
            backgroundImage: `url(${image.url})`,
          }}
        >
            {/* <img
              className="md:w-1/2"
              src={image.url}
              alt={image.name}
            /> */}
        </div>

        <div className="md:w-1/2">
          <div className="p-10 md:px-24">
            <RichText content={text} />
          </div>
        </div>
      </div>
    </Block>
  );
};
